import { ChatGPTCreate } from '@/modules/chatGPT/chatGPT-create';
import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import ChatGPTHome from '../chatGPT/chatGPT.home';
import { BannerSliderEdit } from '../../components/forms/banner-slider-edit.form';

export default function ChatGPTManagementPermission() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case PermissionMode.CREATE:
        return <ChatGPTCreate />;
      case PermissionMode.EDIT:
        return <BannerSliderEdit />;
      default:
        return <ChatGPTHome />;
    }
  };
  return <>{renderContent()}</>;
}
